// critical.js — JS here will be executed before rendering document

/* Add Javascript enabled class*/
document.documentElement.classList.add('js');


/* Add a loading class to document straight away */
document.documentElement.classList.add('loading');

/* Suppress the browser's own scroll restoration on back/forward
 * navigation — our SPA restores scroll itself, keyed to its own saved
 * positions. This must run this early (synchronous, before index.js,
 * which is `defer`red and so runs too late for the browser to honour it)
 * or the browser's native restoration can still apply to the outgoing
 * page before our own navigation logic ever runs. */
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}